import React from 'react';
import './App.css';

import Template from './components/Template';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalErrorBoundary from './components/GlobalErrorBoundary';

import {
  Router,
  Switch,
  Route,
  useLocation,
  Redirect
} from "react-router-dom";


import instructionsPDF from './content/files/instructions.pdf';
import readabilityPDF from './content/files/readability-of-stories.pdf';
import './content/images/images.css';

import MessageContainer from './components/message/MessageContainer'
import RedirectContainer from './components/redirect/RedirectContainer'
import history from './helpers/history'

import Probes from './routers/Probes';
import StoriesDOK from './pages/probes/StoriesDOK';
import Records from './routers/Records';
import Students from './pages/students/Students'
import Home from './pages/home/Home';
import TermsOfUse from './pages/legal/TermsOfUse';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import FrequentlyAskedQuestions from './pages/help/FrequentlyAskedQuestions';
import Help from './pages/help/Help';
import OurStory from './pages/about/OurStory';
import TheProgram from './pages/about/TheProgram';
import UseCases from './pages/about/UseCases';
import Research from './pages/about/Research';
import Testimonials from './pages/about/Testimonials';
import Dashboard from './pages/home/Dashboard';
import Subscribe from './pages/subscribe/Subscribe';
import Summary from './pages/subscribe/Summary';
import Choose from './pages/subscribe/Choose';
import PurchaseOrder from './pages/subscribe/PurchaseOrder';

import SignUp from './pages/account/sign-up/SignUp';
import SignUpSuccess from './pages/account/sign-up/success/Success';

import AddStudent from './pages/students/Add/Add';
import EditStudent from './pages/students/Edit/Edit';
import ShareStudent from './pages/students/Share/Share';
import TransferStudent from './pages/students/Transfer/Transfer';
import ArchiveStudent from './pages/students/Archive/Archive';
import DeleteStudent from './pages/students/Delete/Delete';
import RemoveStudentShare from './pages/students/Share/Remove/Remove';
import ManagedSharedStudents from './pages/students/Share/Manage/Manage';
import EditSharedStudent from './pages/students/Share/Edit/Edit';
import RevokeSharedStudent from './pages/students/Share/Revoke/Revoke';
import Account from './routers/Account'
import ShareSubscriptions from './pages/account/subscription/share/Share'
import ManageSubscriptions from './pages/account/subscription/share/manage/Manage'
import EditSubscriptions from './pages/account/subscription/share/edit/Edit'
import Login from './routers/Login'
import ProbesList from './routers/ProbesList';
import StudentDashboard from './pages/student/Dashboard'
import StudentProbes from './routers/StudentProbes'

import { CustomerRouteSkeleton as CustomerRoute, GuestRouteSkeleton as GuestRoute, StudentRouteSkeleton as StudentRoute } from './helpers/Authenticated'
import authentication from './helpers/authentication'
import Recover from './pages/account/recover/Recover';
import Reset from './pages/account/password/reset/Reset';
import VerifyEmailAddress from './pages/account/verify-email-address/VerifyEmailAddress';
import AcceptTransferRequest from './pages/students/Transfer/accept/Accept';
import Processing from './pages/subscribe/Processing';
import NotFound from './pages/NotFound';
import ResendVerifyEmail from './pages/account/verify-email-address/resend/Resend';
import Unsubscribe from './pages/account/unsubscribe/Unsubscribe'

import Common from './context/Common'
import ReactGA from 'react-ga'


function log(location) {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
}

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// closes mobile navbar when a link is clicked. must be called whenever navbar links change (so when permissions actually change) to attach listener to new links.
function FixNavbar() {
  React.useEffect(() => {
    window.$(function () {
      window.$('.navbar-collapse a, .navbar-brand').not("[href='#']").on('click', function () {
        window.$('.navbar-collapse').collapse('hide');
      });
    });
  });

  return null;
}

function renderFile(filePath) {
  window.location = filePath;

  return (
    <React.Fragment>
      <br />
      <p>You should have been automatically redirected to the file.</p>
      <p>If you have not been redirected, please click <a href={filePath} target="_blank">here</a>.</p>
    </React.Fragment>
  )
}

class App extends React.Component {
  state = {
    auth: null
  }

  updatePermissions = () => {
    return authentication.get()
      .then((user) => {
        this.setState({ auth: user })
        return Promise.resolve(user)
      })
  }

  componentDidMount() {
    this.updatePermissions()
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_TOKEN)

    history.listen((location) => {
      this.updatePermissions()
      log(location)
    })

    log(window.location)
  }

  render() {
    return (
      <GlobalErrorBoundary>
        <Router history={history}>
          <Template auth={this.state.auth} updatePermissions={this.updatePermissions}>
            <ErrorBoundary>
              <FixNavbar />
              <ScrollToTop />
              <Common.Provider value={{ auth: this.state.auth }}>
                <MessageContainer />
                <RedirectContainer />
                <Switch>

                  <Route exact path="/" component={Home} />
                  <StudentRoute exact path="/student/dashboard" component={StudentDashboard} />

                  {
                    ["phonics", "phrases"].map((type) => {
                      return (
                        <StudentRoute exact path={`/student/probes/${type}/:probeNumber`} component={StudentProbes} props={{ type: type }} />)
                    })
                  }


                  {
                    ["high", "middle", "elementary"].map((type) => {
                      return (
                        <StudentRoute exact path={`/student/probes/${type}/:probeNumber`} component={StudentProbes} props={{ type: type }} />
                      )
                    })
                  }

                  <GuestRoute exact path="/account/sign-up" component={SignUp} updatePermissions={this.updatePermissions.bind(this)} />
                  <GuestRoute exact path="/account/sign-up/success" component={SignUpSuccess} updatePermissions={this.updatePermissions.bind(this)} />
                  <GuestRoute exact path="/account/log-in/student" component={Login} props={{ type: "student" }} updatePermissions={this.updatePermissions.bind(this)} />
                  <GuestRoute exact path="/account/log-in/teacher" component={Login} props={{ type: "customer" }} updatePermissions={this.updatePermissions.bind(this)} />

                  <GuestRoute exact path="/account/recover" component={Recover} />
                  <GuestRoute exact path="/account/password/reset" component={Reset} />
                  <GuestRoute exact path="/account/verify-email-address" component={VerifyEmailAddress} updatePermissions={this.updatePermissions.bind(this)} />
                  <GuestRoute exact path="/account/unsubscribe" component={Unsubscribe} />
                  
                  <Route exact path="/legal/terms-of-use" component={TermsOfUse} />
                  <Route exact path="/legal/privacy-policy" component={PrivacyPolicy} />
                  <Route exact path="/help" component={Help} />
                  <Route exact path="/help/frequently-asked-questions" component={FrequentlyAskedQuestions} />

                  {/* <Redirect exact from="/about/" to="/about/the-program" /> // doesn't work properly */}
                  <Route exact path="/about" render={(props) => <Redirect to="/about/the-program" />} />
                  <Route exact path="/about/our-story" component={OurStory} />
                  <Route exact path="/about/the-program" component={TheProgram} />
                  <Route exact path="/about/use-cases" component={UseCases} />
                  <Route exact path="/about/research" component={Research} />
                  <Route exact path="/about/testimonials" component={Testimonials} />

                  <GuestRoute exact path="/students/transfer/accept" component={AcceptTransferRequest} />

                  <CustomerRoute exact path="/dashboard" component={Dashboard} />

                  {/* route to manually redirect to file */}
                  <Route exact path="/file/instructions" render={() => renderFile(instructionsPDF)} />
                  <Route exact path="/help/tutorial/instructions.pdf" render={() => renderFile(instructionsPDF)} />
                  <Route exact path="/file/readability" render={() => renderFile(readabilityPDF)} />

                  {/* 
                  * Student Management Pages
                  */}
                  <CustomerRoute exact path="/students" component={Students} />
                  <CustomerRoute exact path="/students/add" component={AddStudent} />
                  <CustomerRoute exact path="/students/edit" component={EditStudent} />
                  <CustomerRoute exact path="/students/share" component={ShareStudent} />
                  <CustomerRoute exact path="/students/share/remove" component={RemoveStudentShare} />
                  <CustomerRoute exact path="/students/share/manage" component={ManagedSharedStudents} />
                  <CustomerRoute exact path="/students/share/edit" component={EditSharedStudent} />
                  <CustomerRoute exact path="/students/share/revoke" component={RevokeSharedStudent} />
                  <CustomerRoute exact path="/students/transfer" component={TransferStudent} />
                  <CustomerRoute exact path="/students/archive" component={ArchiveStudent} />
                  <CustomerRoute exact path="/students/delete" component={DeleteStudent} />

                  {/* 
                  * Account Information Pages
                  */}
                  <CustomerRoute exact path="/account/information" component={Account} props={{ type: "information" }} />
                  <CustomerRoute exact path="/account/password" component={Account} props={{ type: "password" }} />
                  <CustomerRoute exact path="/account/subscription" component={Account} props={{ type: "subscription" }} />
                  <CustomerRoute exact path="/account/subscription/share" component={ShareSubscriptions} />
                  <CustomerRoute exact path="/account/subscription/share/manage" component={ManageSubscriptions} />
                  <CustomerRoute exact path="/account/subscription/share/edit" component={EditSubscriptions} />


                  {/* 
                  * Probe Pages
                  */}

                  {/* Tried to put these in one big loop using React.Fragment, but the switch was treating it as a rendered Component and rendered a blank page. */}
                  {
                    ["phonics", "phrases"].map((type) => {
                      return (
                        <CustomerRoute exact path={`/probes/${type}/:probeNumber`} component={Probes} props={{ type: type }} />)
                    })
                  }
                  {
                    ["phonics", "phrases"].map((type) => {
                      return (
                        <CustomerRoute exact path={`/probes/${type}`} component={ProbesList} props={{ type: type }} />)
                    })
                  }

                  {
                    ["high", "middle", "elementary"].map((type) => {
                      return (
                        <CustomerRoute exact path={`/probes/stories/${type}/:probeNumber`} component={Probes} props={{ type: type }} />
                      )
                    })
                  }

                  {
                    ["high", "middle", "elementary"].map((type) => {
                      return (
                        <CustomerRoute exact path={`/probes/stories/${type}`} component={ProbesList} props={{ type: type, story: type }} />
                      )
                    })
                  }

                  {
                    ["high", "middle", "elementary"].map((type) => {
                      return (
                        <CustomerRoute exact path={`/probes/stories/${type}/:probeNumber/success`} component={StoriesDOK} props={{ type: type }} />
                      )
                    })
                  }

                  {/* 
                  * Records Pages
                  */}
                  {["phonics", "phrases"].map((type) => {
                    return <CustomerRoute exact path={`/students/records/${type}`} component={Records} props={{ type: type }} />
                  })}

                  {
                    ["high", "middle", "elementary"].map((type) => {
                      return <CustomerRoute exact path={`/students/records/stories/${type}`} component={Records} props={{ type: type }} />
                    })
                  }

                  <GuestRoute exact path="/subscribe" component={Subscribe} props={{ purchaseView: "default" }} />
                  <CustomerRoute exact path="/subscribe/choose" component={Choose} />
                  <CustomerRoute exact path="/subscribe/add" component={Subscribe} props={{ purchaseView: "add" }} />
                  <CustomerRoute exact path="/subscribe/extend" component={Subscribe} props={{ purchaseView: "extend" }} />
                  <CustomerRoute exact path="/subscribe/extend/summary" component={Summary} />
                  <CustomerRoute exact path="/subscribe/purchase-order" component={PurchaseOrder} />
                  <CustomerRoute exact path="/subscribe/processing" component={Processing} />

                  <CustomerRoute exact path="/account/verify-email-address/resend" component={ResendVerifyEmail} />

                  <GuestRoute component={NotFound} />

                </Switch>
              </Common.Provider>
            </ErrorBoundary>
          </Template>
        </Router>
      </GlobalErrorBoundary>
    )
  }
}

export default App;
